import React from 'react';

const NotFound = () => {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1 style={{marginBottom: "2rem"}}>404 - Page Not Found</h1>
      <i className="bi bi-search" style={{fontSize:"5rem", color:"#1B344A", position:"relative"}}><i className="bi bi-question" style={{position:"absolute", top:"50%",left:"50%", transform:"translate(-75%, -75%)", fontSize:"2rem"}}></i></i>
      <p style={{marginTop: "2rem"}}>Sorry, the page you’re looking for doesn’t exist.</p>
    </div>
  );
};

export default NotFound;